import { useState } from "react";
import { CarTaxiFront, History } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { BookRide } from "@/components/customer/BookRide";
import { MyRides } from "@/components/customer/MyRides";
import { useAuth } from "@/context/AuthContext";
import { PhonePrompt } from "@/components/customer/PhonePrompt";

const ITEMS = [
  { key: "book", label: "Book a ride", icon: CarTaxiFront },
  { key: "history", label: "My rides", icon: History },
];

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [tab, setTab] = useState("book");
  return (
    <DashboardShell
      roleLabel="Passenger"
      title={tab === "book" ? `Where to, ${user.name.split(" ")[0]}?` : "Ride history"}
      subtitle={tab === "book" ? "Choose your pickup and drop-off. Pay the driver in cash." : "All your Comfort Taxi trips."}
      items={ITEMS}
      active={tab}
      onChange={setTab}
    >
      <PhonePrompt />
      {tab === "book" ? <BookRide /> : <MyRides />}
    </DashboardShell>
  );
}
